import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_ADGROUP_NOTES,
  CREATE_ADGROUP_NOTES,
  UPDATE_ADGROUP_NOTES,
  DELETE_ADGROUP_NOTES,
} from "./actionTypes";
import {
  getAdgroupNotesSuccess,
  getAdgroupNotesError,
  createAdgroupNotesSuccess,
  createAdgroupNotesError,
  updateAdgroupNotesSuccess,
  updateAdgroupNotesError,
  deleteAdgroupNotesSuccess,
  deleteAdgroupNotesError,
} from "./actions";
import { genericDeleteRequest, genericGetRequest, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper";
import { AppConfiguration } from "config";
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper";

// Get Adgroup Notes
function* onGetAdgroupNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/all_ad_group_notes/${action.payload}`, //campaign id
      {},
      {
        Authorization: adminUser.token,
        "Content-Type": "application/json",
      },
    );
    yield put(getAdgroupNotesSuccess(response));
  } catch (error) {
    yield put(getAdgroupNotesError(error));
  }
}

// Create Adgroup Notes
function* onCreateAdgroupNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/ad_group_notes`,
      {
        body: JSON.stringify({
          ...action.payload,
        }),
        headers: {
          Authorization: adminUser.token,
          "Content-Type": "application/json",
        },
      }
    );
    yield put(createAdgroupNotesSuccess(response));
  } catch (error) {
    yield put(createAdgroupNotesError(error));
  }
}

// Update Adgroup Notes
function* onUpdateAdgroupNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/ad_group_notes/${action.payload.id}`, //ad group note id
      {
        body: JSON.stringify({
          ...action.payload,
        }),
        headers: {
          Authorization: adminUser.token,
          "Content-Type": "application/json",
        },
      }
    );
    yield put(updateAdgroupNotesSuccess(response));
  } catch (error) {
    yield put(updateAdgroupNotesError(error));
  }
}

// Delete Adgroup Notes
function* onDeleteAdgroupNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/ad_group_notes/${action.payload}`, //ad group note id
      {
        method: "DELETE",
        headers: {
          Authorization: adminUser.token,
          "Content-Type": "application/json",
        },
      }
    );
    yield put(deleteAdgroupNotesSuccess(response));
  } catch (error) {
    yield put(deleteAdgroupNotesError(error));
  }
}

function* AdgroupNotesSaga() {
  yield takeEvery(GET_ADGROUP_NOTES, onGetAdgroupNotes);
  yield takeEvery(CREATE_ADGROUP_NOTES, onCreateAdgroupNotes);
  yield takeEvery(UPDATE_ADGROUP_NOTES, onUpdateAdgroupNotes);
  yield takeEvery(DELETE_ADGROUP_NOTES, onDeleteAdgroupNotes);
}

export default AdgroupNotesSaga;
